'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountingService = function () {
  function AccountingService($http, appConfig) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AccountingService);
    this.$http = $http;
    this.appConfig = appConfig;
  }

  (0, _createClass3.default)(AccountingService, [{
    key: 'listProducts',
    value: function listProducts(filterParams) {
      var query = '';

      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
      query += '&ascending=' + filterParams.pageCriteria.ascending;
      query += '&entityId=' + filterParams.entityId;

      if (filterParams.title) {
        query += '&title=' + filterParams.title;
      }

      if (filterParams.createdBy) {
        query += '&createdBy=' + filterParams.createdBy;
      }

      if (filterParams.status) {
        query += '&status=' + filterParams.status;
      }

      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/accounting/listproducts' + query);
    }
  }, {
    key: 'addProduct',
    value: function addProduct(entityId, product) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/accounting/addproduct/' + entityId), product);
    }
  }, {
    key: 'getProduct',
    value: function getProduct(productId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/accounting/getproduct/' + productId));
    }
  }, {
    key: 'editProduct',
    value: function editProduct(entityId, product) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/accounting/editproduct/' + entityId), product);
    }
  }, {
    key: 'updateProductStatus',
    value: function updateProductStatus(entityId, productId, status) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/accounting/updateproductstatus/' + entityId + '/' + productId + '/' + status));
    }
  }, {
    key: 'listInvoices',
    value: function listInvoices(filterParams) {
      var query = '';

      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
      query += '&ascending=' + filterParams.pageCriteria.ascending;
      query += '&entityId=' + filterParams.entityId;

      if (filterParams.number) {
        query += '&number=' + filterParams.number;
      }

      if (filterParams.contact) {
        query += '&contact=' + filterParams.contact;
      }

      if (filterParams.status) {
        query += '&status=' + filterParams.status;
      }

      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/accounting/invoice/list' + query);
    }
  }, {
    key: 'createContact',
    value: function createContact(entityId, contact) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/accounting/createcontact/' + entityId), contact);
    }
  }, {
    key: 'editContact',
    value: function editContact(entityId, contactId, contact) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/accounting/editcontact/' + entityId + '/' + contactId), contact);
    }
  }, {
    key: 'saveDraft',
    value: function saveDraft(entityId, invoice) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/accounting/invoice/savedraft/' + entityId), invoice);
    }
  }, {
    key: 'getInvoice',
    value: function getInvoice(invoiceId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/accounting/invoice/get/' + invoiceId));
    }
  }, {
    key: 'updateInvoiceStatus',
    value: function updateInvoiceStatus(invoiceId, status) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/accounting/invoice/updatestatus/' + invoiceId + '/' + status));
    }
  }, {
    key: 'issueInvoice',
    value: function issueInvoice(invoiceId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/accounting/invoice/issue/' + invoiceId));
    }
  }, {
    key: 'updatePayment',
    value: function updatePayment(entityId, invoiceId, payment) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/accounting/invoice/addpayment/' + entityId + '/' + invoiceId), payment);
    }
  }, {
    key: 'deletePayment',
    value: function deletePayment(entityId, invoicePaymentId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/accounting/invoice/deletepayment/' + entityId + '/' + invoicePaymentId));
    }
  }]);
  return AccountingService;
}();

exports.default = AccountingService;


// WEBPACK FOOTER //
// ./client/app/components/accounting/accounting.service.js